import { createContext, useContext } from "react";

const UserRoleContext = createContext(null);

export const useUserRoleContext = () => useContext(UserRoleContext);

export default UserRoleContext;
